import React, { Component } from "react";
import SaveButton from "../../../components/commons/SaveButton";
import { ModalWithHeader } from "../shared/ui/Modal/Modal";
import { withTranslation } from "react-i18next";
class JoinGroupModal extends Component {
  render() {
    return (
      <div>
        <ModalWithHeader title={this.props.t("common.joinGroup")} closeHandler={this.props.shareModalCloser} show={this.props.show} style={{ backgroundColor: "white", padding: 20, maxWidth: 350 }}>
          <br />
          <input
            type="text"
            placeholder={this.props.t("dashboard.groupCode")}
            onChange={(e) => this.props.changeJoinGroupCode(e)}
            style={{
              border: "1px solid #5555555A",
              padding: 10,
              fontSize: 15,
              borderRadius: 50,
              width: "90%",
            }}
          />
          <SaveButton btnTitle={this.props.t("common.join")} onClick={this.props.addGroupMember} />
        </ModalWithHeader>
      </div>
    );
  }
}

export default withTranslation()(JoinGroupModal)